const DOCUMENT = 'CALENDAR_VIEW_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  EVENTS_FILTERING: DOCUMENT + 'EVENTS_FILTERING',
  LOAD_JOBS: DOCUMENT + 'LOAD_JOBS',
  LOAD_JOBS_SUCCESS: DOCUMENT + 'LOAD_JOBS_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  loadJobs: data => {
    return {
      type: actions.LOAD_JOBS,
      payload: data,
    };
  },

  loadJobsSuccess: data => ({
    type: actions.LOAD_JOBS_SUCCESS,
    payload: data,
  }),

  eventsFiltering: filterProperties => ({
    type: actions.EVENTS_FILTERING,
    filterProperties,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),
};

export default actions;
